/*
  Polyfills intended for use in Zoomforth app (i.e., the dashboard)
*/
import './polyfills_basic.js';
import 'webrtc-adapter/adapter_no_edge.js';
